(function () {
  const STORAGE_KEY = 'sentio_cookie_choice';

  function getBanner() {
    return document.querySelector('[data-sentio-cookie-banner]');
  }

  function showBanner(banner) {
    banner.hidden = false;
    // Force reflow so the transition runs from the hidden state.
    void banner.offsetWidth;
    banner.setAttribute('data-visible', 'true');
  }

  function hideBanner(banner) {
    banner.setAttribute('data-visible', 'false');
    setTimeout(() => {
      banner.hidden = true;
    }, 400);
  }

  function getPrivacyAPI() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function hasStoredChoice() {
    try {
      return Boolean(localStorage.getItem(STORAGE_KEY));
    } catch (_) {
      return false;
    }
  }

  function shouldShow() {
    return !hasStoredChoice();
  }

  function setConsent(api, granted, callback) {
    const consent = {
      analytics: granted,
      marketing: granted,
      preferences: granted,
      sale_of_data: granted,
    };
    try {
      api.setTrackingConsent(consent, callback);
    } catch (err) {
      if (callback) callback();
    }
  }

  function persistChoice(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (_) {
      /* localStorage blocked — banner will reappear on next visit */
    }
  }

  function handleChoice(banner, granted, value) {
    const api = getPrivacyAPI();
    if (api && typeof api.setTrackingConsent === 'function') {
      setConsent(api, granted, () => {
        persistChoice(value);
        hideBanner(banner);
      });
    } else {
      persistChoice(value);
      hideBanner(banner);
    }
  }

  function bindActions(banner) {
    const accept = banner.querySelector('[data-sentio-cookie-accept]');
    const decline = banner.querySelector('[data-sentio-cookie-decline]');

    accept?.addEventListener('click', () => handleChoice(banner, true, 'accepted'));
    decline?.addEventListener('click', () => handleChoice(banner, false, 'declined'));
  }

  function init() {
    const banner = getBanner();
    if (!banner) return;

    bindActions(banner);
    if (shouldShow()) {
      showBanner(banner);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
